"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForecastTypeToJSON = exports.ForecastTypeFromJSONTyped = exports.ForecastTypeFromJSON = exports.ForecastType = void 0;
/**
 * The time granularity of the forecast -- if a "LIFETIME" budget type is specified, the API
 * will return a single "LIFETIME" forecast type and if a "DAILY" budget type is specified, the
 * API will return  "DAILY", "WEEKLY" and "MONTHLY" forecast types.
 *
 * @export
 */
exports.ForecastType = {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY',
    Lifetime: 'LIFETIME'
};
function ForecastTypeFromJSON(json) {
    return ForecastTypeFromJSONTyped(json, false);
}
exports.ForecastTypeFromJSON = ForecastTypeFromJSON;
function ForecastTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ForecastTypeFromJSONTyped = ForecastTypeFromJSONTyped;
function ForecastTypeToJSON(value) {
    return value;
}
exports.ForecastTypeToJSON = ForecastTypeToJSON;
